
export type SearchHashtagsParams = {
query: string;
limit?: number;
};
